module.exports = __webpack_public_path__ + "img/puberty-decal-27.f5a4ce18.png";